@if (country$ | async; as res) {
  @if (res.error || !res.page) {
    <div class="cg-container--marketing py-16 text-center">
      <h1 class="text-xl font-semibold text-slate-800">Country not found</h1>
      <p class="mt-3 text-slate-600">This destination is not available or not published.</p>
      <a routerLink="/" class="cg-mkt-btn cg-mkt-btn--primary mt-6 inline-block">Back to home</a>
    </div>
  } @else {
    @let p = res.page;
    <div class="bg-slate-50">
      <app-marketing-header variant="country" />
      <app-marketing-hero
        [hero]="{
          variant: 'country',
          eyebrow: p.hero.eyebrow,
          title: p.hero.title,
          lede: p.hero.lede,
          primaryCta: p.hero.primaryCta,
          image: p.hero.image,
        }"
      />
      <app-marketing-stats-strip [stats]="p.stats" />
      <section class="cg-mkt-section cg-mkt-section--alt cg-section" id="why">
        <div class="cg-container--marketing">
          <app-marketing-section-heading [eyebrow]="p.why.eyebrow" [title]="p.why.title" [subtitle]="p.why.subtitle" />
          @if (p.why.cards.length) {
            <div class="cg-mkt-grid">
              @for (card of p.why.cards; track card.title) {
                <article class="cg-mkt-card overflow-hidden p-0">
                  @if (card.image?.cdnUrl) {
                    <div class="cg-mkt-uni-card__media">
                      <img [src]="card.image!.cdnUrl!" [alt]="card.title" loading="lazy" />
                    </div>
                  }
                  <div class="p-4">
                    <h3 class="m-0 font-semibold">{{ card.title }}</h3>
                    <p class="mt-2 text-sm text-slate-600">{{ card.description }}</p>
                  </div>
                </article>
              }
            </div>
          }
        </div>
      </section>
      @if (hasGlobalStoriesSection(homeContent())) {
        @let home = homeContent()!;
        <section class="h1-section h1-section--warm" id="global-success-stories">
          <div class="h1-section__inner">
            <header class="h1-section__head h1-section__head--center">
              <h2>{{ home.successStories.title ?? 'Global Success Stories' }}</h2>
              <p>
                {{
                  home.successStories.subtitle
                    ?? 'Real journeys, life-changing achievements, and global impact.'
                }}
              </p>
            </header>
            @if (successStoryItems(home).length) {
              <app-marketing-global-success-stories [stories]="successStoryItems(home)" />
            }
            @if (testimonialItems(home).length) {
              <app-marketing-testimonials [items]="testimonialItems(home)" />
            }
          </div>
        </section>
      }
      @if (p.costs.items.length || p.costs.blocked || p.costs.intro) {
        <app-marketing-country-costs
          [title]="p.costs.title ?? 'Understanding the Costs'"
          [intro]="p.costs.intro"
          [items]="p.costs.items"
          [blocked]="p.costs.blocked"
        />
      }
      <app-marketing-success-roadmap />
      <app-marketing-blog-country-strip [posts]="countryBlogs()" [countrySlug]="p.slug" />
      @if (p.scholarships.length) {
        <section class="cg-mkt-section cg-mkt-section--alt cg-section">
          <div class="cg-container--marketing">
            <app-marketing-section-heading title="Scholarships" />
            <app-marketing-scholarships [items]="p.scholarships" />
          </div>
        </section>
      }
      @if (p.faq.length) {
        <section class="cg-mkt-section cg-section" id="faq">
          <div class="cg-container--marketing">
            <app-marketing-section-heading title="FAQ" />
            <app-marketing-faq [items]="p.faq" />
          </div>
        </section>
      }
      <section class="cg-section" id="cta">
        <div class="cg-container--marketing">
          <app-marketing-consultation-cta
            [preferredDestination]="p.name"
            [sourcePage]="'/countries/' + p.slug"
          />
        </div>
      </section>
      <app-marketing-footer />
    </div>
  }
}
